import React, { useEffect, useMemo, useState } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import dayjs from 'dayjs';
import { getAllPosts } from '@/services/gonggongjiekou';
import { cn } from '@/shared/utils/shadcn';

const LatestNews = ({ className }: { className?: string }) => {
  const t = useTranslations();

  const [selectedCountryTag, setSelectedCountryTag] = useState<number>(149); // 资讯动态选中的国家 - 默认选中加拿大
  const [immigrationList, setImmigrationList] = useState<any[]>([]); //星环移民 最新资讯动态-移民
  const [studyAbroadList, setStudyAbroadList] = useState<any[]>([]); //星环移民 最新资讯动态-留学
  const [socialList, setSocialList] = useState<any[]>([]); //星环移民 最新资讯动态-社会

  // 获取资讯动态文章列表
  useEffect(() => {
    // 移民
    getAllPosts({ categories: 146, per_page: 100 }).then((res) => {
      console.log('移民', res);
      setImmigrationList(res?.data || []);
    });
    // 留学
    getAllPosts({ categories: 148, per_page: 100 }).then((res) => {
      console.log('留学', res);
      setStudyAbroadList(res?.data || []);
    });
    // 社会
    getAllPosts({ categories: 147, per_page: 100 }).then((res) => {
      console.log('社会', res);
      setSocialList(res?.data || []);
    });
  }, []);

  const immigrationRenderList = useMemo(() => {
    return immigrationList.filter((item) => (item.tags || []).includes(selectedCountryTag)).slice(0, 7);
  }, [immigrationList, selectedCountryTag]);
  const studyAbroadRenderList = useMemo(() => {
    return studyAbroadList.filter((item) => (item.tags || []).includes(selectedCountryTag)).slice(0, 7);
  }, [studyAbroadList, selectedCountryTag]);
  const socialRenderList = useMemo(() => {
    return socialList.filter((item) => (item.tags || []).includes(selectedCountryTag)).slice(0, 7);
  }, [socialList, selectedCountryTag]);

  return (
    <div className={cn('box-border w-full px-[10.4vw] max-md:px-[30px] max-md:py-6', className)}>
      <h2 className="mb-5 text-[46px] font-semibold leading-[46px] text-[#111111] max-md:mb-2 max-md:text-lg max-md:font-semibold max-md:leading-[18px]">
        {t('Home.news')}
      </h2>
      <h2 className="mb-[67px] text-[36px] font-extrabold uppercase leading-[36px] text-[#E2E2E2] max-md:mb-6 max-md:text-base">
        {t('Home.newsAndTrends')}
      </h2>
      <div className="mb-[50px] flex w-full flex-row items-center justify-start max-md:mb-5">
        {[
          { value: 149, label: '加拿大' },
          { value: 160, label: '美国' },
          { value: 150, label: '欧洲' },
          { value: 156, label: '亚洲' },
          { value: 161, label: '澳洲' },
          { value: 162, label: '加勒比' },
          // { value: 157, label: '新加坡' },
          // { value: 158, label: '中国香港' },
          // { value: 159, label: '其他' },
        ].map((item, index) => (
          <div
            key={index}
            className="mr-24 flex flex-col items-center justify-center max-md:mr-4"
            onClick={() => setSelectedCountryTag(item.value)}
          >
            <div
              className={`mb-[26px] cursor-pointer max-md:mb-2 ${selectedCountryTag === item.value ? 'text-2xl font-semibold leading-6 text-[#111111] max-md:text-sm' : 'text-lg font-normal leading-[18px] text-[#333333] max-md:text-sm'} `}
            >
              {item.label}
            </div>
            {selectedCountryTag === item.value && <div className="h-1 w-[38px] bg-[#1A228B]"></div>}
          </div>
        ))}
      </div>
      <div className="flex w-full flex-row justify-between max-md:flex-col">
        {[
          { value: 'studyAbroad', label: '留学' },
          { value: 'immigration', label: '移民' },
          { value: 'social', label: '资讯' },
        ].map((item, index) => {
          return (
            <div
              key={index}
              className="box-border flex w-[23.92vw] flex-col items-center justify-start bg-white pb-11 pt-6 max-md:mb-4 max-md:w-full max-md:px-3 max-md:py-3"
              style={{ boxShadow: '0px 7px 21px 3px rgba(42,42,42,0.17)' }}
            >
              <div className="w-[20.8vw] max-md:w-full">
                <div className="mb-6 flex w-full flex-row items-center justify-between max-md:mb-3">
                  <div className="text-xl font-semibold leading-5 text-[#111111] max-md:text-base">{item.label}</div>
                  {/* <Link href="" className="text-base font-normal leading-4 text-[#666666]">
                      {t('Home.more')}
                    </Link> */}
                </div>
                <div className="mb-[26px] h-[1px] w-full bg-[#A6A6A6] max-md:mb-4"></div>
                <div className="mb-5 h-[11.44vw] w-full bg-slate-600 max-md:mb-3 max-md:h-auto">
                  <Image
                    src={`/images/home/${item.value}.png`}
                    width={400}
                    height={220}
                    className="h-full w-full max-md:h-auto"
                    alt={item.value}
                  />
                </div>
                {(item.value === 'studyAbroad'
                  ? studyAbroadRenderList || []
                  : item.value === 'immigration'
                    ? immigrationRenderList || []
                    : socialRenderList || []
                )?.length > 0 ? (
                  <>
                    <div
                      className="mb-7 w-full cursor-pointer text-base font-semibold text-[#111111] max-md:mb-3 max-md:text-sm"
                      onClick={() => {
                        const link =
                          item.value === 'studyAbroad'
                            ? studyAbroadRenderList.length > 0
                              ? studyAbroadRenderList[0]?.link
                              : ''
                            : item.value === 'immigration'
                              ? immigrationRenderList.length > 0
                                ? immigrationRenderList[0]?.link
                                : ''
                              : socialRenderList.length > 0
                                ? socialRenderList[0]?.link
                                : '';

                        if (link) {
                          if (link.startsWith('http') || link.startsWith('https')) {
                            window.open(link, '_blank');
                          } else {
                            window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${link}`, '_blank');
                          }
                        }
                      }}
                    >
                      {item.value === 'studyAbroad'
                        ? studyAbroadRenderList.length > 0
                          ? studyAbroadRenderList[0]?.title?.rendered
                          : ''
                        : item.value === 'immigration'
                          ? immigrationRenderList.length > 0
                            ? immigrationRenderList[0]?.title?.rendered
                            : ''
                          : socialRenderList.length > 0
                            ? socialRenderList[0]?.title?.rendered
                            : ''}
                    </div>
                    {(item.value === 'studyAbroad'
                      ? studyAbroadRenderList || []
                      : item.value === 'immigration'
                        ? immigrationRenderList || []
                        : socialRenderList || []
                    )
                      .slice(1, 6)
                      .map((item1: any, index1) => (
                        <div
                          key={index1}
                          className="mb-[26px] flex w-full cursor-pointer flex-row items-center justify-between last:mb-0 max-md:mb-3"
                          onClick={() => {
                            const link = item1?.link;
                            if (link) {
                              if (link.startsWith('http') || link.startsWith('https')) {
                                window.open(link, '_blank');
                              } else {
                                window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${link}`, '_blank');
                              }
                            }
                          }}
                        >
                          <div className="flex w-[18px] flex-row items-center justify-center">
                            <div className="size-[6px] rounded-full bg-[#4C4C4C] max-md:size-1"></div>
                          </div>
                          <div className="flex-1 truncate text-sm text-[#666666] max-md:text-xs">
                            {item1?.title?.rendered}
                          </div>
                          <div className="w-16 text-right text-sm text-[#666666] max-md:text-xs">
                            {item1?.date ? dayjs(item1?.date).format('MM-DD') : ''}
                          </div>
                        </div>
                      ))}
                  </>
                ) : (
                  <div className="mb-7 w-full text-center text-base font-semibold text-[#e2e2e2] max-md:mb-3 max-md:text-sm">
                    {t('Home.noData')}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LatestNews;
